import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Table, message, Modal, Icon, Input, Button } from 'antd';
import InputField from '../../components/global/InputField';
import swal from 'sweetalert';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import { getCompaniesData } from '../../actions/index';
import './ManageUsersV2.css';
import Translation from '../../Translation';
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}
const dateSort = (a, b) => {
    if (new Date(a).getTime() < new Date(b).getTime()) { return -1; }
    if (new Date(a).getTime() > new Date(b).getTime()) { return 1; }
    return 0;
}
/**
 * Class for ManageUsersV2.
 *
 * @class ManageUsersV2
 * @extends {React.Component}
 */
class ManageUsersV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isModalVisible: false,
            isLongMessageModalVisible: false,
            rows: [],
            apiData: [],
            messagesList: [],
            longMessageText: '',
            userRole: 'user',
            userCompany: '',
            username: null,
            isAdd: true,
            emailAddress: '',
            firstName: '',
            lastName: '',
            password: '',
            cpassword: '',
            errorMessage: null,
            isCreateLoading: false,

            visibleProcessModal: false,
            usersToImportCount: 0,
            importedUsersCount: 0,
            selectedRowKeys: [],
            processStartIndex: 0,
            maxNoOfUsersToProcess: 50,

            processingCount: 0,
            usersWaitingToCreate: 0,
            isInvitationInProgress: false,
            invitationsCount: 0,
            requestsCount: 0
        }
        this.columns = [{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Email"/>,
            key: 'email',
            sorter: (a, b) => stringSort(a['username'], b['username']),
            align: 'left',
            render: (rec) => {
                return (<span>{rec.email || rec.username}</span>);
            },
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => (record['username'] || "").toString().toLowerCase().includes(value.toLowerCase())
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="First Name"/>,
            key: 'firstName',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            sorter: (a, b) => {
                let aFirstName = (a.oktaProfile && a.oktaProfile.firstName);
                aFirstName = (a.azureProfile && a.azureProfile.firstName) || aFirstName;
                let bFirstName = (b.oktaProfile && b.oktaProfile.firstName);
                bFirstName = (b.azureProfile && b.azureProfile.firstName) || bFirstName;
                return stringSort(aFirstName, bFirstName);
            },
            render: (rec) => {
                let firstName = (rec.oktaProfile && rec.oktaProfile.firstName);
                firstName = (rec.azureProfile && rec.azureProfile.firstName) || firstName;
                return (<span>{firstName}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.firstName);
                valueToCheck = (rec.azureProfile && rec.azureProfile.firstName) || valueToCheck;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Last Name"/>,
            key: 'lastName',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            sorter: (a, b) => {
                let aLastName = (a.oktaProfile && a.oktaProfile.lastName);
                aLastName = (a.azureProfile && a.azureProfile.lastName) || aLastName;
                let bLastName = (b.oktaProfile && b.oktaProfile.lastName);
                bLastName = (b.azureProfile && b.azureProfile.lastName) || bLastName;
                return stringSort(aLastName, bLastName);
            },
            render: (rec) => {
                let lastName = (rec.oktaProfile && rec.oktaProfile.lastName);
                lastName = (rec.azureProfile && rec.azureProfile.lastName) || lastName;
                return (<span>{lastName}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.lastName);
                valueToCheck = (rec.azureProfile && rec.azureProfile.lastName) || valueToCheck;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Role"/>,
            key: 'role',
            align: 'left',
            nocustomfilter: true,
            filters: [
                {
                    text: <Translation labelName="role_lbl_admin" defaultText="Admin" />,
                    value: 'admin',
                },
                {
                    text: <Translation labelName="role_lbl_ce_user" defaultText="CE User" />,
                    value: 'ce-user',
                },
                {
                    text: <Translation labelName="role_lbl_user" defaultText="User" />,
                    value: 'user',
                }
            ],
            onFilter: (value, rec) => {
                let role = (rec.oktaProfile && rec.oktaProfile.role);
                role = (rec.azureProfile && rec.azureProfile.role) || role || "";
                return role.toUpperCase() === value.toUpperCase();
            },
            sorter: (a, b) => {
                let aRole = (a.oktaProfile && a.oktaProfile.role);
                aRole = (a.azureProfile && a.azureProfile.role) || aRole || "";
                let bRole = (b.oktaProfile && b.oktaProfile.role);
                bRole = (b.azureProfile && b.azureProfile.role) || bRole || "";
                return stringSort(aRole, bRole);
            },
            render: (rec) => {
                let role = (rec.oktaProfile && rec.oktaProfile.role);
                role = (rec.azureProfile && rec.azureProfile.role) || role || "";
                return (<span>{role}</span>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Company"/>,
            key: 'company',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            sorter: (a, b) => {
                let aCompany = (a.oktaProfile && a.oktaProfile.company);
                aCompany = (a.azureProfile && a.azureProfile.company) || aCompany || "";
                let bCompany = (b.oktaProfile && b.oktaProfile.company);
                bCompany = (b.azureProfile && b.azureProfile.company) || bCompany || "";
                return stringSort(aCompany, bCompany);
            },
            render: (rec) => {
                let company = (rec.oktaProfile && rec.oktaProfile.company);
                company = (rec.azureProfile && rec.azureProfile.company) || company || "";
                return (<span>{company}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.company);
                valueToCheck = (rec.azureProfile && rec.azureProfile.company) || valueToCheck;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Last Login"/>,
            key: 'lastLogin',
            align: 'center',
            sorter: (a, b) => {
                let aTime = new Date(1989, 4, 4).getTime();
                let bTime = new Date(1989, 4, 4).getTime();
                if (a.lastLogin && a.lastLogin.length > 0) {
                    aTime = a.lastLogin.indexOf('Z') < 0 ? a.lastLogin - 0 : a.lastLogin;
                }
                if (b.lastLogin && b.lastLogin.length > 0) {
                    bTime = b.lastLogin.indexOf('Z') < 0 ? b.lastLogin - 0 : b.lastLogin;
                }
                return dateSort(aTime, bTime);
            },
            render: (rec) => {
                if (rec.lastLogin && rec.lastLogin.length > 0) {
                    let lastLoginToCheck = rec.lastLogin.indexOf('Z') < 0 ? rec.lastLogin - 0 : rec.lastLogin;
                    let lastLoginDate = new Date(lastLoginToCheck);
                    let timeDiff = window.currentServerTimestamp - lastLoginDate.getTime();
                    let inMinutes = Math.floor(timeDiff / (1000 * 60));
                    let lastLoginTime = 'Just now';
                    if (inMinutes > 1) {
                        lastLoginTime = `${inMinutes} minutes ago`;
                    }
                    if (inMinutes > 60) {
                        let inHours = Math.floor(inMinutes / 60);
                        lastLoginTime = `${inHours} hours ago`;
                        if (inHours >= 24) {
                            let inDays = Math.floor(inHours / 24);
                            lastLoginTime = `${inDays} days ago`;
                            if (inDays > 10) {
                                let lastLoginYear = lastLoginDate.getFullYear();
                                let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
                                let lastLoginMonth = monthNames[lastLoginDate.getMonth()];
                                let lastLoginDay = lastLoginDate.getDate();
                                lastLoginTime = `${lastLoginMonth} ${lastLoginDay}, ${lastLoginYear}`;
                            }
                        }
                    }
                    return (<span>{ lastLoginTime }</span>);    
                }
                return (<span>-</span>);
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_azure_status" defaultText="In sync (Azure)"/>,
            align: 'center',
            render: (rec) => {
                if (rec.azureProfile && rec.azureProfile.azureId) {
                    return (<span>Yes</span>);
                }
                return (<span>
                    <a className="table-links" href="#" onClick={(e) => this.syncToAzure(e, rec)}><Translation labelName="lbl_sync_now" defaultText="Sync now" /></a>
                </span>);
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_invitation_status" defaultText="Invitation"/>,
            key: 'sendInvitation',
            align: 'center',
            sorter: (a, b) => {
                return stringSort(a.sendInvitation, b.sendInvitation);
            },
            render: (rec) => {
                if (rec.sendInvitation) {
                    if (rec.sendInvitation === 'SENT') {
                        return (<span>Sent</span>);
                    }
                    if (rec.sendInvitation === 'WAITING') {
                        return (<span>In Queue</span>);
                    }
                }
                return (<span>-</span>);
            }
        }];
    }

    syncToAzure = (e, rec) => {
        e.preventDefault();
        CelaneseAPI.post('/sync-users', {
            "users": [rec]
        }).then(resp => {
            // swal({
            //     title: utils.getTranslationText('msg_creating_invitation_job_success','Syncing user to azure is completed'),
            //     text: utils.getTranslationText('msg_sending_invitation_job_process','Sending invitation to users in background, we will send job status to your email address'),
            //     buttons: [utils.getTranslationText('btn_ok','OK')],
            //     timer: 3000
            // });
            this.getMessagesList();
        });
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TranslationTable
     */
     filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys[0]}
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof TranslationTable
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TranslationTable
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof TranslationTable
     */
     handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     * @param {func} clearFilters
     * @memberof TranslationTable
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount() {
        this.setState({
            loading: true
        });
        getCompaniesData().then((res) => {
            this.setState({
                apiData: res && res.data ? res.data : []
            });
        }).catch(() => { });
        this.getMessagesList();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                apiData: nextProps.companiesData
            });
        }
    }

    showAddUserModal = (e) => {
        this.setState({ 
            isAdd: true, 
            visibleCompany: true, 
            errorMessage: null,

            username: '',
            password: '',
            firstName: '',
            lastName: '',
            emailAddress: '',
            cpassword: '',
            userRole: 'user',
            userCompany: ''
        });
    }
    showImportUsersModal = (e) => {
        this.setState({
            visileImportModal: true,
            importJobStatus: []
        });
    }
    showDeleteWarning = (e) => {
        e.preventDefault();
        if (this.state.selectedRowKeys.length === 0) {
            swal({
                text: 'Please select atleast one user to delete',
                button: utils.getTranslationText('btn_ok','OK'),
            });
        } else {
            swal({title: utils.getTranslationText('msg_are_u_sure', 'Are you sure?'),
                text: utils.getTranslationText('msg_delete_selected_users', 'This will delete selected users'),
                icon: 'warning',
                buttons: [ utils.getTranslationText('btn_cancel', 'Cancel'), utils.getTranslationText('btn_continue', 'Continue')],
                dangerMode: true,
            }).then((confirm)=> {
                if(confirm) {
                    swal({
                        text: utils.getTranslationText('msg_deleting_users','Deleting users...'),
                        buttons: false,
                        closeOnClickOutside: false
                    });
                    CelaneseAPI.post('/delete-users', {
                        "users": this.state.rows.filter(item => (this.state.selectedRowKeys.indexOf(item.username) >= 0))
                    }).then(resp => {
                        swal({
                            title: utils.getTranslationText('msg_delete_success','Deleted Successful'),
                            text: utils.getTranslationText('msg_deleting_users_done_successfully','Deleting users is done successfully'),
                            buttons: [utils.getTranslationText('btn_ok','OK')],
                            timer: 3000
                        });
                        this.getMessagesList();
                    });
                }
            });
        }
    }
    showInvitationModal = (e) => {
        e.preventDefault();
        if (this.state.selectedRowKeys.length === 0 || this.state.selectedRowKeys.length > 20) {
            swal({
                text: 'Please select atleast one user or maximum 20 users to send invitation',
                button: utils.getTranslationText('btn_ok','OK'),
            });
        } else {
            swal({
                title: utils.getTranslationText('msg_invitations_sent_started','Invitation sending process started'),
                text: utils.getTranslationText('msg_user_invitations_started','Please dont close the browser or refresh during the process'),
                buttons: false,
                closeOnClickOutside: false
            });
            this.setState({
                isInvitationInProgress: true,
                invitationsCount: this.state.selectedRowKeys.length
            });
            CelaneseAPI.post('/start-email-job', {
                "users": this.state.rows.filter(item => (this.state.selectedRowKeys.indexOf(item.username) >= 0))
            }).then(resp => {
                let maximumconcurrency = 5;
                let selectedKeys = this.state.selectedRowKeys;
                let concurencyCount = this.state.selectedRowKeys.length > maximumconcurrency ? maximumconcurrency : this.state.selectedRowKeys.length;
                for (let i = 0; i < concurencyCount; i++) {
                    this.startInvitationProcess(selectedKeys.pop());
                }
                this.setState({
                    selectedRowKeys: selectedKeys,
                    requestsCount: concurencyCount
                });
            });
        }
    }
    startInvitationProcess = (username) => {
        CelaneseAPI.post('/send-welcome-invitation', {
            username
        }).then(resp => {
            if (this.state.invitationsCount >= 1) {
                let selectedKeys = this.state.selectedRowKeys;
                let userToInvite = selectedKeys.pop();
                if (userToInvite) {
                    this.startInvitationProcess(userToInvite);
                    this.setState({
                        selectedRowKeys: selectedKeys,
                        invitationsCount: this.state.invitationsCount - 1
                    });
                } else {
                    this.setState({
                        selectedRowKeys: [],
                        isInvitationInProgress: false
                    });
                    swal({
                        title: utils.getTranslationText('msg_invitations_sent_success','Invitation sending process completed'),
                        text: utils.getTranslationText('msg_invitations_sent_done_successfully','Invitation emails are sent successfully'),
                        buttons: [utils.getTranslationText('btn_ok','OK')],
                        timer: 3000
                    });
                    this.getMessagesList();
                }
            } else {
                if (this.state.isInvitationInProgress) {
                    this.setState({
                        selectedRowKeys: [],
                        isInvitationInProgress: false
                    });
                    swal({
                        title: utils.getTranslationText('msg_invitations_sent_success','Invitation sending process completed'),
                        text: utils.getTranslationText('msg_invitations_sent_done_successfully','Invitation emails are sent successfully'),
                        buttons: [utils.getTranslationText('btn_ok','OK')],
                        timer: 3000
                    });
                    this.getMessagesList();
                }
            }
        });
    }
    chooseFile = (e) => {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('#file-import').click();
    }

    // importFile = (e) => {
    //     e.preventDefault();
    //     let inputElem = document.querySelector('input[type="file"]');
    //     let extenstion = inputElem.value.split('.json')[1];
    //     if (!inputElem.value)
    //         return;
    //     if (extenstion === '') {
    //         swal({
    //             text: utils.getTranslationText('msg_validating_file','Validating File...'),
    //             buttons: false,
    //             className: 'import-btn-swal',
    //             closeOnClickOutside: false
    //         });
    //         const files = inputElem.files;
    //         const formData = new FormData();
    //         for (let i = 0; i < files.length; i++) {
    //             let file = files[i];
    //             formData.append('file', file);
    //         }
    //         inputElem.value = '';

    //         CelaneseAPI.post('/validate-import-users', formData, { isUpload: true }).then(validateResp => {
    //             console.log(validateResp);
    //             if (validateResp.data && validateResp.data instanceof Array) {
    //                 swal.close();
    //                 this.setState({
    //                     usersToImportCount: validateResp.data.length,
    //                     processStartIndex: 0,
    //                     usersToCreate: validateResp.data,
    //                     processingCount: 0,
    //                     usersWaitingToCreate: validateResp.data.length
    //                 });
    //                 this.showImportProcessModal();
    //             } else {
    //                 swal({
    //                     text: 'Validation failed',
    //                     button: utils.getTranslationText('btn_ok','OK'),
    //                 });
    //             }
    //         });
    //     } else {
    //         swal({
    //             text: utils.getTranslationText('msg_json_files_only', 'Json files only'),
    //             buttons: [utils.getTranslationText('btn_ok','OK')]
    //         });
    //     }
    // }

    showImportProcessModal = (e) => {
        this.setState({
            visibleProcessModal: true
        });

        this.processNextbatch();
    }

    processNextbatch = () => {
        let usersToCreate = this.state.usersToCreate.slice(this.state.processStartIndex, this.state.processStartIndex + this.state.maxNoOfUsersToProcess);
        if (usersToCreate.length > 0) {
            this.setState({
                processStartIndex: this.state.processStartIndex + this.state.maxNoOfUsersToProcess,
                processingCount: this.state.processingCount + usersToCreate.length,
                usersWaitingToCreate: this.state.usersWaitingToCreate - usersToCreate.length
            });
            CelaneseAPI.post('/import-users', {
                "users": usersToCreate
            }).then(resp => {
                this.processNextbatch();
            });
        } else {
            this.setState({
                visibleProcessModal: false
            });
            swal({
                title: utils.getTranslationText('msg_import_success','Import Successful'),
                text: utils.getTranslationText('msg_Importing_users_done_successfully','Importing users is done successfully'),
                buttons: [utils.getTranslationText('btn_ok','OK')],
                timer: 3000
            });
            this.getMessagesList();
        }
    }

    showAddCompanyModal = (e, rec) => {
        e && e.preventDefault();
        this.setState({
            visibleCompany: true,
            editCompanyData: rec ? rec : '',
            username: rec.username,
            isAdd: false,
            errorMessage: null,
            emailAddress: rec.username,
            firstName: rec.azureProfile && rec.azureProfile.firstName ? rec.azureProfile.firstName : '',
            lastName: rec.azureProfile && rec.azureProfile.lastName ? rec.azureProfile.lastName: '',
            userRole: rec.azureProfile && rec.azureProfile.role ? rec.azureProfile.role: 'user',
            userCompany: rec.azureProfile && rec.azureProfile.company ? rec.azureProfile.company: ''
        });
    }

    /**
     * success function shows a success message when message is created successfully
     * @param {string} msg custom message to be shown
     * @memberof ManageUsers
     */
    success = (msg) => {
        message.success(msg, 2);
    }

    /**
     * error function shows a error message
     * @memberof ManageUsers
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    cancelAction = () => {
    }

    /**
     * showMessagePreview function shows a preview content wrapper
     * @param {event} e event is passed
     * @param {object} rec manage message row record is passed
     * @memberof ManageUsers
     */
    showMessagePreview = (e, rec) => {
        e.preventDefault();
        const quickPreviewWrapper = document.querySelector('.quick-preview-message');
        const manageUsersTable = document.querySelector('.cmp-manage-messages__table-wrapper');
        if (rec.id && quickPreviewWrapper) {
            if (quickPreviewWrapper.offsetHeight) {
                manageUsersTable.style['height'] = (manageUsersTable.offsetHeight + quickPreviewWrapper.offsetHeight) + 'px';
            }
            quickPreviewWrapper.querySelector('.quick-preview-message-content').innerHTML = rec.subject + (rec.text && rec.text.length ? ` <a href="#" data-long-message-id= ${ rec.id } class="quick-preview-message-readmore" id="showLargeDescription">${utils.getTranslationText('link_read_more','Read More')}</a>` : '');
            quickPreviewWrapper.classList.remove('displayNone');
            document.querySelector('.main').style['padding-top'] = document.querySelector('.celanese-header').offsetHeight + 'px';
            manageUsersTable.style['height'] = (manageUsersTable.offsetHeight - quickPreviewWrapper.offsetHeight) + 'px';
            this.showLongMessageModal();
        }
    }

    /**
     * showLongMessageModal function is for showing long message modal
     * @memberof ManageUsers
     */
    showLongMessageModal = () => {
        const self = this;
        document.getElementById('showLargeDescription').addEventListener('click', (e) => {
            e.preventDefault();
            const messageId = e && e.target ? e.target.getAttribute('data-long-message-id') : null;
            if (messageId) {
                let index = 0;
                const longTextRecord = self.state.messagesList.filter((val, i) => {
                    if (val.id === messageId) {
                        index = i;
                    }
                    return true;
                });
                this.setState({
                    isLongMessageModalVisible: true,
                    longMessageText: longTextRecord.length ? longTextRecord[index].text : ''
                });
            }
        }, false);
    }

    /**
     * confirmDeleteAction function deletes the message created by the admin
     * @param {*} e here e is an event passed
     * @param {object} rec here rec refers to the record of the message being deleted
     * @memberof ManageUsers
     */
    confirmDeleteAction = (e, rec) => {
        e.preventDefault();
        if (rec.id) {
            this.setState({
                loading: true
            });
            CelaneseAPI.delete(config.API.manageUsersById.replace(':id', rec.id)).then(res => {
                if (!res.error) {
                    this.success(utils.getTranslationText('msg_user_dlt_success', 'User deleted Successfully'));
                    this.getMessagesList();
                } else {
                    this.error(utils.getTranslationText('msg_error_occured_dlt_user', 'Error occured while deleting the User'));
                }
                this.setState({
                    loading: false
                });
            }).catch(() => {
                this.error(utils.getTranslationText('msg_error_occured_dlt_user', 'Error occured while deleting the User'));
                this.setState({
                    loading: false
                });
            });
        }
    }

    /**
     * showManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageUsers
     */
    showManageMessageModal = () => {
        this.setState({
            isModalVisible: true
        });
    }

    handleCompanyCancel = () => {
        this.setState({
            visibleCompany: false,
        });
    }

    /**
     * hideManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageUsers
     */
    hideManageMessageModal = () => {
        this.setState({
            isModalVisible: false
        });
    }

    /**
     * hideLongMessageModal function is for hiding a modal which is for creating messages
     * @memberof ManageUsers
     */
    hideLongMessageModal = () => {
        this.setState({
            isLongMessageModalVisible: false
        });
    }

    /**
     * getMessagesList function is for getting list of all messages which are entered by the admin
     * @memberof ManageUsers
     */
    getMessagesList = () => {
        this.setState({
            loading: true
        });
        CelaneseAPI.get(config.API.manageUsers).then(resp => {
            this.setState({
                messagesList: resp && resp.data ? resp.data : [],
                loading: false,
                rows: resp && resp.data ? resp.data : []
            });
        });
    }

    onCreateMessageSuccess = () => {
        this.setState({
            isModalVisible: false
        });
        this.getMessagesList();
    }

    sendEmailInvitation = (formData) => {
        CelaneseAPI.post(config.API.sendInvitation, {
            "to": formData['emailAddress'],
            "firstname": formData['firstName'],
            "lastname": formData['lastName'],
            "loginUrl": window.location.origin,
            "password": formData['password']
        }).then(resp => {

        });
    }

    updateRoleAndCompany = () => {
        if (this.state.isAdd) {
            this.setState({
                isCreateLoading: true
            });
            
            let formData = {
                "emailAddress": this.state.emailAddress,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "password": this.state.password,
                "role": this.state.userRole,
                "company": this.state.userCompany,
                "forceChangePasswordNextSignIn": true
            };
            CelaneseAPI.post(config.API.manageUsers, formData).then((resp) => {
                console.log("resp", resp);
                if (resp.error) {
                    let errorToShow = 'Unable to create user, please check your fields';
                    if (resp.error.code) {
                        if (resp.error.code === 'USER_ALREADY_EXISTS') {
                            errorToShow = 'User already exists in Towplus application';
                        }
                    }
                    if (resp.error.message) {
                        errorToShow = resp.error.message;
                        if (resp.error.message.indexOf('userPrincipalName already exists') >= 0) {
                            errorToShow = 'User already exists in Azure portal';
                        }
                    }
                    this.setState({
                        isCreateLoading: false,
                        errorMessage: errorToShow
                    });
                } else {
                    this.getMessagesList();
                    message.success(utils.getTranslationText('msg_user_created_success', 'User created Successfully'), 2);
                    this.sendEmailInvitation(formData);
                    this.setState({
                        isCreateLoading: false,
                        visibleCompany: false
                    });
                }
            });
        } else {
            this.setState({
                visibleCompany: false,
                loading: true
            });
            CelaneseAPI.post(config.API.updateUserRoleAndCompany, {
                username: this.state.username,
                role: this.state.userRole,
                company: this.state.userCompany,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
            }).then(() => {
                this.getMessagesList();
                message.success(utils.getTranslationText('msg_user_updated_success', 'User updated Successfully'), 2);
            })
        }
    }
    updateUserRole = (e) => {
        let userCompany = this.state.userCompany;
        if (e.target.value && e.target.value.toUpperCase() === 'admin'.toUpperCase() && 
            e.target.value.toUpperCase() === 'ce-user'.toUpperCase()) {
            userCompany = '';
        }
        this.setState({
            userRole: e.target.value,
            userCompany
        });
    }
    updateUserCompany = (e) => {
        this.setState({
            userCompany: e.target.value
        });
    }
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_user_items','Fetching user items'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds','Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting towitems in excel format
         */
        CelaneseAPI.getBlob('/export-users?format=excel').then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-users-link');
            if(document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'user-items-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'user-items-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }
    exportFile(e) {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: utils.getTranslationText('msg_database','Database has zero tow items, Do you want to continue to export with empty tow items?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }
    }

    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    render() {
        return (
            <Fragment>
                <div className="cmp-manage-messages__header ">
                    <BreadcrumbHeading heading={<Translation labelName="title_admin_manage_users" defaultText="Manage Users"/>} />
                    <div className="cmp-manage-messages__header-links manage-users-v2">
                        <div className="cmp-manage-messages__header-links-wrapper">
                            {
                                this.state.rows.length ? (
                                    <h4 className="users-length-label"><Translation labelName="lbl_available_user_items" defaultText="User items" />: <strong>{this.state.rows.length}</strong></h4>
                                ) : ''
                            }
                            <button type="button" className="btn btn-default create-user-btn m2-left" onClick={(e) => this.getMessagesList(e)}><Translation labelName="btn_refresh" defaultText="Refresh" /></button>
                            <button type="button" className="btn btn-default create-user-btn m2-left" onClick={(e) => this.showDeleteWarning(e)}><Translation labelName="btn_delete_users" defaultText="Delete Users" /></button>
                            <button type="button" className="btn btn-default create-user-btn m2-left" onClick={(e) => this.showInvitationModal(e)}><Translation labelName="btn_send_invitation" defaultText="Send Invitation" /></button>

                            {/* <button type="button" className="btn btn-default create-user-btn m2-left" onClick={(e) => this.chooseFile(e)}><Translation labelName="btn_import_users" defaultText="Import Users" /></button> */}
                            {/* <input id="file-import" onChange={(e) => this.importFile(e)} type='file' accept='.json' /> */}
                        </div>
                        
                        {/* <button
                            type="button"
                            onClick={this.showManageMessageModal}
                            className="btn btn-default create-message-link"><Translation labelName="btn_create_message" defaultText="Create Message"/>
                        </button> */}
                    </div>
                </div>
                <div className="cmp-manage-messages">
                    <div className="cmp-manage-messages__table-wrapper">
                        <Table
                            dataSource={this.state.rows}
                            rowSelection={{selectedRowKeys: this.state.selectedRowKeys, onChange: (selectedRowKeys) => {this.setState({ selectedRowKeys });} }}
                            columns={this.columns}
                            rowKey={(rec) => { return rec['username'] }}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            scroll={{ y: 'calc(100vh - 230px)' }}
                            size="middle" />
                    </div>
                </div>
                {this.state.visibleCompany &&
                    <Modal
                        className="update-role-company"
                        title={ 
                            this.state.isAdd ? 
                                <Translation labelName="title_create_user" defaultText="Create User"/> : 
                                <Translation labelName="title_update_role_company" defaultText="Update role and company"/>
                            }
                        visible={this.state.visibleCompany}
                        okText={
                            this.state.isAdd ?
                            <Translation labelName="btn_save" defaultText="Submit"/> :
                            <Translation labelName="btn_save" defaultText="Save"/> 
                        }
                        onOk={() => this.updateRoleAndCompany()}
                        onCancel={this.handleCompanyCancel}
                        centered
                        width='750px'
                    >
                        <div>
                            {
                                this.state.errorMessage &&
                                (
                                    <div className="error-text">
                                        {this.state.errorMessage}
                                    </div>
                                )
                            }
                            {
                                this.state.isAdd && (
                                    <Fragment>
                                        <div>
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_email_address" defaultText="Email address "/>*</Fragment>}
                                                name='emailAddress'
                                                pattern='^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                                id='emailAddress'
                                                value={this.state.emailAddress}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                        
                                    </Fragment>
                                )
                            }
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_firstname" defaultText="Firstname "/>*</Fragment>}
                                        name='firstName'
                                        id='firstName'
                                        value={this.state.firstName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_lastname" defaultText="Lastname "/>*</Fragment>}
                                        name='lastName'
                                        id='lastName'
                                        value={this.state.lastName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="user-preference__row">
                                <label htmlFor="userRole"><Translation labelName="hdr_user_role" defaultText="Role"/></label>
                                <select value={this.state.userRole ? this.state.userRole : ''} name="userRole" onChange={this.updateUserRole}>
                                    {(
                                        [{
                                            value: "admin",
                                            key: "Admin"
                                        }, {
                                            value: 'ce-user',
                                            key: 'CE User'
                                        }, {
                                            value: 'user',
                                            key: 'User'
                                        }].map((val, i) => {
                                            return (<option key={i} value={val.value}>{ val.key }</option>);
                                        })
                                    )}
                                </select>
                            </div>
                            {
                                this.state.userRole === 'user' && (
                                    <div className="user-preference__row">
                                        <label htmlFor="userCompany"><Translation labelName="lbl_user_company" defaultText="Company Name"/></label>
                                        <select value={this.state.userCompany} name="userCompany" onChange={this.updateUserCompany}>
                                            <Translation labelName="lbl_none" defaultText="None" isOption />
                                            {this.state.apiData && (
                                                this.state.apiData.map((val, i) => {
                                                    return (<option key={i} value={val.company}>{val.company}</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                )
                            }
                            {
                                this.state.isCreateLoading && <div className="loading-indicator">
                                    <h2 className="loading-indicator-text">
                                        {/* <Icon type="loading" theme="outlined" /> */}
                                        <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                                    <span>Loading</span></h2>
                                </div>
                            }
                        </div>
                    </Modal>}
                {
                    this.state.visibleProcessModal && (
                        <Modal
                            className="import-users-modal"
                            title={ <Translation labelName="title_importing_users" defaultText="Importing users"/> }
                            visible={this.state.visibleProcessModal}
                            maskClosable='false'
                            closable={false}
                            footer={null}
                            centered
                            width='500px'
                        >
                            <div className="modal-content">
                                <div>Please don't close or refresh the browser while importing users</div>
                                <div className="process-item"><Icon type="check-circle" style={{ color: 'green' }} /> <span className="process-item__text">Uploaded file validation</span></div>
                                <div className="process-item"><Icon type="check-circle" style={{ color: 'green' }} /> <span className="process-item__text">Found <b>{this.state.usersToImportCount}</b> users</span></div>
                                <div className="process-item"><Icon type="loading" style={{ color: 'green' }} /> <span className="process-item__text"><b>{this.state.usersWaitingToCreate}</b> users waiting to import</span></div>
                                
                                {/* <div className="progress-table">
                                    <div>In progress: 0</div>
                                    <div>Failed: 0</div>
                                    <div>Success: 0</div>
                                    <div>Waiting: 0</div>
                                </div> */}
                            </div>
                        </Modal>
                    )   
                }
                <a href="" className="export-users-hidden" id="export-users-link" download=""></a>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsersV2);

ManageUsersV2.propTypes = {
    prefData: PropTypes.object,
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/containers/ManageUsersV2/index.js